import { render, staticRenderFns } from "./InfiniteSelect.vue?vue&type=template&id=3285d2dd"
import script from "./InfiniteSelect.vue?vue&type=script&lang=js"
export * from "./InfiniteSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3285d2dd')) {
      api.createRecord('3285d2dd', component.options)
    } else {
      api.reload('3285d2dd', component.options)
    }
    module.hot.accept("./InfiniteSelect.vue?vue&type=template&id=3285d2dd", function () {
      api.rerender('3285d2dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/ui/components/infiniteSelect/InfiniteSelect.vue"
export default component.exports